// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__pZmTK","formItem":"styles_formItem__4gBCZ","formFull":"styles_formFull__+j1vb","InputNumber":"styles_InputNumber__+bOUc"};